import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import Submitting from 'shared/Submitting.jsx';
import StandardField from 'shared/StandardField.jsx';
import StandardTextArea from 'shared/StandardTextArea.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';
import scrollToFirstError from '../actions';

const SetupForm = ({
  pristine,
  submitting,
  readOnly,
  handleSubmit,
  onCancel,
  onSubmit
}) => (
  <div className="flex center animated fadeIn">
    <form
      className="col-xs-12 col-lg-8"
      onSubmit={handleSubmit(onSubmit)}>
      <ErrorListContainer />

      <div className="panel panel-default">
        <div className="panel-heading">
          <h4 className="panel-title">{`User Messages`} </h4>
        </div>
        <div className="panel-body">

          <Field
            name="marketingMessage"
            type="text"
            component={StandardTextArea}
            placeholder="This message will be shown to captains on the View Squads screen"
            label="Captain's Squad Message"
            maxLength="250"
            disabled={readOnly}
          />

          <Field
            name="rosterMessage"
            type="text"
            component={StandardTextArea}
            placeholder="This message will be shown to captains on the Manage Roster screen"
            label="Captain's Roster Message"
            maxLength="250"
            disabled={readOnly}
          />

          <Field
            name="paymentSuccessMessage"
            type="text"
            component={StandardTextArea}
            placeholder="This message will be shown to captains when a payment is successfuly completed"
            label="Payment Success Message"
            maxLength="250"
            disabled={readOnly}
          />

          <Field
            name="paymentFailureMessage"
            type="text"
            component={StandardTextArea}
            placeholder="This message will be shown to captains when a payment fails"
            label="Payment Failure Message"
            maxLength="250"
            disabled={readOnly}
          /> 
        </div>
      </div>

      <div className="panel panel-default">
        <div className="panel-heading">
          <h4 className="panel-title">{`Email Template IDs`} </h4>
        </div>
        <div className="panel-body">
          <Field
            name="welcomeEmailTemplateId"
            type="text"
            component={StandardField}
            placeholder="SendGrid Template Id for email when captain purchases entries"
            label="Captain Purchase Email Template Id"
            maxLength="36"
            disabled={readOnly}
          />

          <Field
            name="adminReservationEmailTemplateId"
            type="text"
            component={StandardField}
            placeholder="SendGrid Template Id for email when captain reserves via Admin"
            label="Entry Reservation Email Template Id"
            maxLength="36"
            disabled={readOnly}
          />

          <Field
            name="bowlerAddedToRosterEmailTemplateId"
            type="text"
            component={StandardField}
            placeholder="SendGrid Template Id for email when bowler is added to roster"
            label="Roster Addition Email Template Id"
            maxLength="36"
            disabled={readOnly}
          />

          <Field
            name="squadChangedEmailTemplateId"
            type="text"
            component={StandardField}
            placeholder="SendGrid Template Id for email when squad is changed"
            label="Squad Changed Email Template Id"
            maxLength="36"
            disabled={readOnly}
          />
        </div>
      </div>
 
      <div className="form-group text-right">
          <button
            type="button"
            className="btn btn-link"
            disabled={submitting}
            onClick={onCancel}
          >Cancel</button>
          {` `}
          <button
            type="submit"
            className="btn btn-primary btn-lg"
            disabled={pristine || submitting}
          >{submitting ? <Submitting /> : <i className="fa fa-floppy-o" />} {"Update"}</button>
        </div>

    </form>
  </div>
);

SetupForm.propTypes = {
  error: PropTypes.string,
  pristine: PropTypes.bool.isRequired, 
  submitting: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func
};

export default reduxForm({
  form: 'tournamentCom',
  onSubmitFail: (errors) => scrollToFirstError(errors)
})(SetupForm);



// WEBPACK FOOTER //
// ./src/features/tournament/communications/CommunicationForm.jsx